import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';

@Component({
  selector: 'app-workspace',
  templateUrl: './workspace.html',
  styleUrls: ['./workspace.scss'],
  standalone: false,
})
export class Workspace {
  constructor(
    public loginService: LoginService,
    public router: Router
  ) {}

  // Sidebar shell is for authenticated in-app routes only — never over login or privacy (same rule app-root used before).
  get showSidebar(): boolean {
    const path = this.router.url.split('?')[0].split('#')[0];
    return (
      !!this.loginService.username &&
      !this.loginService.clinicOptions &&
      path !== '/' &&
      path !== '/privacy-policy'
    );
  }
}
